import React, { useMemo } from 'react';

import { Route, Switch } from 'react-router-dom';
import { Box } from '@material-ui/core';

import { EmployeeTimeLogsProvider } from '@vyce/core/src/contexts';
import { CommonNavBarBlock } from '@vyce/core/src/components';
import { EmployeeLocationPage } from '@vyce/core/src/modules/employeeTimeLogsModule/EmployeeLocationPage';

import { EmployeeTimeLogsPage } from 'src/views/payroll/employee/EmployeeTimeLogsPage';
import { TimeEmployeeDailyActivity } from 'src/modules';
import { useTypedSelector } from 'src/hooks';

import { EMPLOYEE_TIME_AND_ATTENDANCE_TABS } from './config';
import { EmployeeLocationsPage } from '../payroll/employee/EmployeeLocationsPage';

export const EmployeeTimeLogs = () => {
  const { first_name } = useTypedSelector(state => state.user);

  const contextOptions = useMemo(() => ({ first_name }), [first_name]);

  return (
    <EmployeeTimeLogsProvider value={contextOptions}>
      <Switch>
        <Box>
          <CommonNavBarBlock tabItems={EMPLOYEE_TIME_AND_ATTENDANCE_TABS} />
          <Box height="100%">
            <Route exact path={'/timelogs/logs'} component={EmployeeTimeLogsPage} />
            <Route exact path={'/timelogs/locations-shifts/:locationId'} component={EmployeeLocationPage} />
            <Route exact path={'/timelogs/locations-shifts'} component={EmployeeLocationsPage} />
            <Route
              exact
              path={'/timelogs/logs/:companyId/:shiftId/:userId/:date'}
              component={TimeEmployeeDailyActivity}
            />
          </Box>
        </Box>
      </Switch>
    </EmployeeTimeLogsProvider>
  );
};
